import axiosInstance from "./axios";
import {
  CreatePackagePayload,
  Package,
  UpdatePackagePayload,
} from "./models/package.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchAllPackages = async (
  bearerToken,
  companyId
): Promise<Package[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Products/${companyId}/packages`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch packages:", error);
    throw error;
  }
};

export const fetchSinglePackageWithIdentifier = async (
  bearerToken: string,
  companyId: number,
  identifier: string
): Promise<Package> => {
  try {
    const url = `${apiUrl}/Products/${companyId}/packages/${identifier}`;

    const response = await axiosInstance.get(url, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch akeneo package:", error);
    throw error;
  }
};

export const createPackage = async (
  bearerToken: string,
  payload: CreatePackagePayload
): Promise<Package> => {
  try {
    const response = await axiosInstance.post(
      `${apiUrl}/Products/${payload.companyId}/packages`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create package:", error);
    throw error;
  }
};

export const updatePackage = async (
  bearerToken: string,
  payload: UpdatePackagePayload
): Promise<Package> => {
  try {
    const response = await axiosInstance.patch(
      `${apiUrl}/Products/${payload.companyId}/packages`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create update package:", error);
    throw error;
  }
};
